/* import __COLOCATED_TEMPLATE__ from './line-reg.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();